// extracted by mini-css-extract-plugin
export default {"changeLanguageBox":"index_changeLanguageBox__hWluh","title":"index_title__UkJEc","checkList":"index_checkList__C-8sT"};